import React from 'react';
import axios from "../../containers/api";
import {Alert, Button, FormGroup, Label} from "reactstrap";
import {showCatchError} from "../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

class UpdateDriverTurn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Salon: null,
            errors: [],
            oneDriver: this.props && this.props.driver,
            SalonList: []
        }
    }

    componentDidMount() {
        this.getSalons();
    }

    getSalons = () => {
        this.props.showSpinner();
        axios.get('api/VirtualSalonApi/GetVirtualSalons')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({SalonList: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];

        if (this.state.Salon === null || this.state.Salon === "") {
            error.push("لطفا سالن مورد نظر را انتخاب کنید");
        }

        this.setState({ errors: error });
        if (error.length === 0) {
            this.UpdateDriverTurn();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };
    UpdateDriverTurn = () => {
        let searchModel = {
            Item2: this.state.Salon.virtualSalon.virtualSalonId,
            Item1: this.state.oneDriver.driverID,
        };

        this.props.showSpinner();
        axios.post('api/VirtualSalonDriverTurnApi/Active_TurnForDriver', searchModel)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert("نوبت راننده با موفقعیت فعال شد!", 'success');
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            })
    };

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };

    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-50 w-100 px-1">
                        <Label>سالن</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="Salon"
                            options={this.state.SalonList}
                            getOptionLabel={(option) => option.virtualSalon.name}
                            value={this.state.Salon}
                            onChange={(e, v) => this.selectHandleChange(e, v, "Salon")}
                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                        />
                    </FormGroup>
                </div>

                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.props.showSweetAlert("آیا از فعال کردن نوبت این راننده مطمئن هستید؟", "", "success", this.validateInputData)}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>

            </div>
        );
    }
}

export default UpdateDriverTurn;